import { FontWeight, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { TextStyleOptions } from '../../../../core/setting/text/IText';
import { BLEND_MODES } from "pixi.js";
import { Helper } from "../../../../core/utils/Helper";
import { SoundManager } from "../../../config/sound/SoundManager";

enum interactiveEvents{
    HOVER,
    HOVER_OUT,
    CLICK,
    TAP,
    HOLD,
    RELEASED
}

export class SpriteButton extends PIXI.Container {

    protected BUTTON_STYLE: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontStyle: FontStyle.ITALIC,
        fontSize: 34,
        fill: "#ffffff",
        fontWeight: FontWeight.EXTRA_BOLD
    };

    protected callBack: Function | undefined = () => { };
    protected callBack_hover: Function | undefined = () => { };
    
    protected button_Sp: PIXI.Sprite;
    protected button_Sp_FX: PIXI.Sprite;
    protected eventCall: interactiveEvents;

    protected soundTrigger: string;

    protected animationTimeline:gsap.core.Timeline;

    constructor(_texture:PIXI.Texture, cb?: Function, text?:string,  style?:TextStyleOptions) {
        super();

        if(style) this.BUTTON_STYLE = style;

        this.sortableChildren = true;
        this.button_Sp = this.addChild(new PIXI.Sprite(_texture));
        this.button_Sp.anchor.set(0.5);

        this.button_Sp_FX = this.addChild(new PIXI.Sprite(_texture));
        this.button_Sp_FX.anchor.set(0.5);
        this.button_Sp_FX.blendMode = BLEND_MODES.ADD;
        this.button_Sp_FX.alpha = 0;

        this.SetInteractive(false, cb);

        this.on('mouseover', () => {
            this.eventTriggered(interactiveEvents.HOVER)
        });

        this.on('mouseout', () => {
            this.eventTriggered(interactiveEvents.HOVER_OUT)
        });
    }

    SetPressSound(_sound:string){
        this.soundTrigger = _sound;
    }

    SetInteractive(val:boolean, cb?: Function){ 
        this.interactive = val;
        if(cb) this.setCallBack(cb,true); 
    }

    SetHoverCB(cb: Function){ 
        if(cb) this.callBack_hover = cb;
    }

    private eventTriggered(event:interactiveEvents):void{
        if(event != this.eventCall) this.eventCall = event;
        else return;

        switch(event){
            case interactiveEvents.HOVER:
                this.hoverFeature(true);
                break;
            case interactiveEvents.HOVER_OUT:
                this.hoverFeature(false);
                break;
            default:
                break;
        }
    }

    private tlHover:gsap.core.Timeline
    private hoverFeature(onObj:boolean){
        if(this.callBack_hover) this.callBack_hover(onObj);
        this.tlHover = Helper.setTimeline(this.tlHover);
        this.tlHover.to(this.button_Sp_FX,{alpha: onObj ? 0.3 : 0, duration:0.1 });
    }

    public animateClick():void{
        this.tlHover = Helper.setTimeline(this.tlHover);
        SoundManager.playSoundEffect(this.soundTrigger);
        this.animationTimeline = Helper.setTimeline(this.animationTimeline,{onComplete:() => {
            this.button_Sp_FX.alpha = this.eventCall == interactiveEvents.HOVER ? 0.3 : 0
        }});

        const durr = 0.25;
        this.animationTimeline.to(this.scale,  { x: 1.2, y: 1.2, duration: durr },0);
        this.animationTimeline.to(this.scale,  { x: 1, y: 1, duration: durr/2 },durr/2);

        this.animationTimeline.to(this.button_Sp_FX,  { alpha:0.7, duration: durr },0);
        this.animationTimeline.to(this.button_Sp_FX,  { alpha: this.eventCall == interactiveEvents.HOVER ? 0.3 : 0, duration: durr/2 },durr/2);
    }

    public setCallBack(cb:Function, multiClick?:boolean){
        this.off("pointerdown"); // Remove anything that lingers
        if(multiClick){
            this.on("pointerdown", () => cb());
        }else
            this.once("pointerdown", () => cb());
    }
}
